module.exports = __webpack_public_path__ + "img/73ne.3e93e1f4.svg";